import React from "react";
import { useTranslation } from "react-i18next";
import { Box, IconButton, Stack, useTheme } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import CloseIcon from "@mui/icons-material/Close";
import moment from "moment";

import Button from "components/basic/button";
import Typography from "components/basic/typography";
import { Booking } from "../../types";

interface BookingBannerProps {
  booking: Booking;
  onView: () => void;
  onDismiss: () => void;
}

const BookingBanner: React.FC<BookingBannerProps> = ({
  booking,
  onView,
  onDismiss,
}) => {
  const theme = useTheme();
  const { t } = useTranslation("calendar");

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        backgroundColor: theme.palette.background.paper,
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: 1,
        boxShadow: 2,
        px: 2,
        py: 1,
        mb: 1,
      }}
    >
      <InfoOutlinedIcon sx={{ color: theme.palette.warning.main }} />
      <Typography variant="body2" style={{ flex: 1, fontWeight: 500 }}>
        {`${booking.title} scheduled for ${moment(booking.date).format(
          "MMMM D",
        )}`}
      </Typography>
      <Stack direction="row" spacing={0.5} alignItems="center">
        <Button
          variant="outlined"
          color="primary"
          onClick={onView}
          endAdornment={<ChevronRightIcon fontSize="small" />}
        >
          {t("banner.view")}
        </Button>
        <IconButton size="small" onClick={onDismiss}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </Stack>
    </Box>
  );
};

export default BookingBanner;
